import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useBreakpoint } from '~/composables';
import CatalogCategoryItem from '~/components/sections/categorySection/CatalogCategoryItem.vue';

type CategoryItem = {
  [key: string]: string | any;
  order?: number;
  orderMobile?: number;
};

interface Props {
  data?: { id?: string; items: CategoryItem[] };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesSection',
  props: {
    data: { default: () => ({ items: [] }) }
  },
  setup(__props: any) {

const props = __props as { data: { id?: string; items: CategoryItem[] } };



const grid = {
  cols: 'grid-cols-8',
  rows: 'auto-rows-[49vw] sm:auto-rows-[222px] md:auto-rows-[206px] lg:auto-rows-[251px] xl:auto-rows-[276px] 2xl:auto-rows-[309px] 3xl:auto-rows-[373px]',
  colSpan: {
    1: 'col-span-4 md:col-span-2',
    1.5: 'col-span-4 md:col-span-3',
    2: 'col-span-8',
  } as Record<number, string>,
  rowSpan: {
    1: 'row-span-1',
    2: 'row-span-1 sm:row-span-3 md:row-span-2',
  } as Record<number, string>,
};

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const items = computed<CategoryItem[]>(() =>
  props.data?.items
    ?.map((item, i) => {
      const order = item.order ?? i;
      const orderMobile = item.orderMobile ?? order;

      return { ...item, order, orderMobile };
    })
    .sort((a, b) =>
      isDesktop.value ? a.order - b.order : a.orderMobile - b.orderMobile,
    ),
);

const isWide = (i: number) =>
  i === items.value.length - 1 && !isDesktop.value && items.value.length % 2;

return { __sfc: true,props, grid, isDesktop, items, isWide, CatalogCategoryItem }
}

})